module.exports = __webpack_public_path__ + "static/media/riester.71442dab.png";